import script from "./UiConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UiConfirmDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__